import { cfgCdnBanners, cfgToThemeCdnPath, FeatureSet, Theme } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export function makeBanners(theme, featureSet, localeCode) {
    const BANNERS_CDN = cfgCdnBanners();
    const BANNERS_BASE = featureSet === FeatureSet.Preview ? `${BANNERS_CDN}staging/` : `${BANNERS_CDN}`;
    const locSegment = localeCode !== 'en' ? `/${localeCode}` : '';
    const imgUrl = (file) => cfgToThemeCdnPath(`/banner${locSegment}/${file}`);
    const imgUrlEn = (file) => cfgToThemeCdnPath(`/banner/${file}`);
    const bannerSetOnlyImage = (id) => {
        const locFolder = localeCode !== 'en' ? `${localeCode}/` : '';
        return {
            bannerMobile: `${BANNERS_BASE}${id}/${locFolder}${id}-mobile.png`,
            banner: `${BANNERS_BASE}${id}/${locFolder}${id}.png`,
            // fallbacks EN
            fallbackMobile: `${BANNERS_BASE}${id}/${id}-mobile.png`,
            fallback: `${BANNERS_BASE}${id}/${id}.png`
        };
    };
    const bannersFlush = [
        {
            id: 1,
            url: '/promotion-page/',
            img: imgUrl('auth-banner-2.png'),
            imgMobile: imgUrl('auth-banner-2-mobile.png'),
            ...(localeCode !== 'en' && {
                fallbackImg: imgUrlEn('auth-banner-2.png'),
                fallbackImgMobile: imgUrlEn('auth-banner-2-mobile.png')
            }),
            show: true,
            title: Verbiage.welcome_offer_text,
            description: Verbiage.welcome_offer_description_text
        },
        {
            id: 2,
            url: '/vip/',
            img: imgUrl('auth-banner-1.png'),
            imgMobile: imgUrl('auth-banner-1-mobile.png'),
            ...(localeCode !== 'en' && {
                fallbackImg: imgUrlEn('auth-banner-1.png'),
                fallbackImgMobile: imgUrlEn('auth-banner-1-mobile.png')
            }),
            show: true,
            title: Verbiage.best_vip_club,
            description: Verbiage.best_vip_club_description
        }
    ];
    const fomoFreeSpins = bannerSetOnlyImage('free_spins');
    const bannersGeneric = [];
    const bannersFomo = [
        {
            id: 1,
            url: '/promotion-page/',
            img: imgUrl('auth-fomo.png'),
            imgMobile: imgUrl('auth-fomo-mobile.png'),
            ...(localeCode !== 'en' && {
                fallbackImg: imgUrlEn('auth-fomo.png'),
                fallbackImgMobile: imgUrlEn('auth-fomo-mobile.png')
            }),
            show: false
        },
        {
            id: 2,
            url: '/',
            img: fomoFreeSpins.bannerMobile,
            imgMobile: fomoFreeSpins.bannerMobile,
            ...(localeCode !== 'en' && {
                fallbackImg: fomoFreeSpins.fallbackMobile,
                fallbackImgMobile: fomoFreeSpins.fallbackMobile
            }),
            show: featureSet === FeatureSet.Preview,
            showOnly: 'register'
        }
    ];
    const bannersRocketbet = [
        {
            id: 1,
            url: '/promotion-page/jackpot/',
            img: imgUrl('auth-banner-1.png'),
            imgMobile: imgUrl('auth-banner-1-mobile.png'),
            ...(localeCode !== 'en' && {
                fallbackImg: imgUrlEn('auth-banner-1.png'),
                fallbackImgMobile: imgUrlEn('auth-banner-1-mobile.png')
            }),
            show: true,
            title: Verbiage.jackpot_brand,
            description: Verbiage.jackpot_description_2
        }
    ];
    const bannersTurboslots = [
        {
            id: 1,
            url: '/promotion-page/jackpot/',
            img: imgUrl('auth-banner-1.png'),
            imgMobile: imgUrl('auth-banner-1-mobile.png'),
            ...(localeCode !== 'en' && {
                fallbackImg: imgUrlEn('auth-banner-1.png'),
                fallbackImgMobile: imgUrlEn('auth-banner-1-mobile.png')
            }),
            show: true,
            title: Verbiage.jackpot_brand,
            description: Verbiage.jackpot_description_2
        }
    ];
    const byTheme = (() => {
        switch (theme) {
            case Theme.Flush:
                return bannersFlush;
            case Theme.Fomo:
                return bannersFomo;
            case Theme.Rocketbet:
                return bannersRocketbet;
            case Theme.Turboslots:
                return bannersTurboslots;
            default:
                return bannersGeneric;
        }
    })();
    return byTheme.filter((b) => b.show);
}
